import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import * as R from "ramda";
import React from "react";
import {ToggleButton} from "@mui/material";

export const formGroupApproval = {
    approvalId: {value: ""},
    approvalDescription: {value: ""},
    approvalAhassLine: {value: {}, mandatory: true},
    approvalMarketingLine: {value: {}, mandatory: true},
    approvalAdminLine: {value: {}, mandatory: true},
    status: {value: "ACTIVE"},
};

export const tableColumns = (
    menuAccess,
    dataTable,
    handleModifyingModalVisibility,
    handleChangeStatus,
) => {
    return [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "approvalId",
            label: "ID Pelanggaran",
        },
        {
            name: "approvalDescription",
            label: "Deskripsi Pelanggaran",
        },
        {
            name: "approvalAhassLine",
            label: "Ahas Line",
        },
        {
            name: "approvalMarketingLine",
            label: "Mkt Line",
        },
        {
            name: "approvalAdminLine",
            label: "Adm Line",
        },
        {
            name: "",
            label: "Aksi",
            options: {
                customBodyRender: (_, tableMeta) => {
                    return (
                        <FlexView vAlignContent="center">
                            {menuAccess && menuAccess.updateAccess && (
                                <SimpleButton
                                    category="action_button"
                                    style={{marginRight: 15, backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lw fa-pencil-alt"/>}
                                    onClick={() => handleModifyingModalVisibility(tableMeta.rowIndex)}
                                />
                            )}
                            {menuAccess && menuAccess.updateAccess && (
                                <ToggleButton
                                    value={R.equals(dataTable[tableMeta.rowIndex].status, "ACTIVE")}
                                    onToggle={(value) => handleChangeStatus(tableMeta.rowIndex, !value)}
                                />
                            )}
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];
}